import { Flex, Text, Box, IconButton, useColorModeValue, Button, VStack } from "@chakra-ui/react";
import { FiLogOut, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { resetCurrentDepartment } from "../../store/slices/departments";
import { useNavbar } from "@/context/NavbarContext";
import { PanelLeft } from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { NotificationBell } from "../NotificationBell/NotificationBell";

export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("#e5e7eb", "#e5e7eb");
  const textColor = useColorModeValue("blue.600", "white");
  const { toggleNavbar } = useNavbar();
  const [showLogoutWarning, setShowLogoutWarning] = useState(false);
  const warningRef = useRef(null);

  const handleLogout = () => {
    setShowLogoutWarning(true);
  };

  const confirmLogout = () => {
    navigate("/login");
    localStorage.removeItem("token");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("middle_name");
    localStorage.removeItem("role");
    localStorage.removeItem("department_id");
    localStorage.removeItem("channel_id");
    dispatch(resetCurrentDepartment());
    setShowLogoutWarning(false);
  };

  const cancelLogout = () => {
    setShowLogoutWarning(false);
  };

  // Закрытие при клике вне области предупреждения
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (warningRef.current && !warningRef.current.contains(event.target)) {
        setShowLogoutWarning(false);
      }
    };

    if (showLogoutWarning) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showLogoutWarning]);

  return (
    <Box position="relative">
      <Flex
        padding="0 24px"
        height="64px"
        w="100%"
        backgroundColor={bgColor}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor={borderColor}
        position="sticky"
        top={0}
        zIndex={1000}
      >
        <IconButton
          icon={<PanelLeft color="#808080" />}
          onClick={toggleNavbar}
          variant="ghost"
          alignSelf="center"
          aria-label="Свернуть/развернуть меню"
          size="sm"
        />
        <Flex alignItems="center" gap="24px" borderLeft={`1px solid ${borderColor}`} height="32px" paddingLeft="24px">
          <Flex alignItems="center" gap={2}>
            <Box
              p={2}
              borderRadius="full"
              border="1px solid"
              borderColor={borderColor}
              display="flex"
              alignItems="center"
              justifyContent="center"
              _hover={{ bg: "blue.50" }}
              transition="all 0.2s"
            >
              <FiUser color={textColor} size={20} />
            </Box>
            <Text fontSize="md" color={textColor} fontWeight="medium">
              {localStorage.getItem("last_name")} {localStorage.getItem("first_name")} {localStorage.getItem("middle_name")}
            </Text>
          </Flex>

          <NotificationBell />

          <IconButton
            aria-label="Выйти"
            icon={<FiLogOut />}
            variant="ghost"
            color={textColor}
            _hover={{ bg: "blue.50" }}
            onClick={handleLogout}
            size="sm"
          />
        </Flex>
      </Flex>

      {showLogoutWarning && (
        <Box position="absolute" top="64px" right="24px" zIndex={1001} w="280px">
          <Box
            ref={warningRef}
            bg="white"
            border="1px solid"
            borderColor="blue.200"
            borderRadius="lg"
            boxShadow="0 10px 25px rgba(59, 130, 246, 0.15)"
            p={4}
          >
            <VStack spacing={3} align="stretch">
              <Text fontSize="md" fontWeight="semibold" color="blue.700" textAlign="center">
                Вы уверены?
              </Text>
              <Flex gap={2} justify="center">
                <Button
                  size="sm"
                  variant="outline"
                  colorScheme="blue"
                  onClick={cancelLogout}
                  _hover={{ bg: "blue.50" }}
                  color="blue.600"
                  borderColor="blue.300"
                >
                  Отмена
                </Button>
                <Button size="sm" colorScheme="blue" onClick={confirmLogout} bg="blue.600" _hover={{ bg: "blue.700" }}>
                  Выйти
                </Button>
              </Flex>
            </VStack>
          </Box>
        </Box>
      )}
    </Box>
  );
};
